export default "__VITE_ASSET__673d4140__"